export const isAppDialogOpen = state => state.appDialog.isOpen;

export const getDialogAction = state => state.appDialog.action;

export const getUsers = state =>
    state.appDialog.usersIds &&
    state.appDialog.usersIds.map(userId => state.db.users[userId]);



// WEBPACK FOOTER //
// ./src/selectors/appDialogSelectors.js